import React from 'react';
import './ConfirmModal.scss';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

const ConfirmModal = ({ closeModal,
                        onClose,
                        onOk,
                        title,
                        message,
                        okButtonName=null,
                        okButtonText='Ok',
                        cancelButtonName = null,
                        cancelButtonText = 'Cancel',
                      }) => {
  return (
    <div className="confirmation-modal-content">
      <div className="confirmation-modal-body">

        <div className="info-icon">
          <FontAwesomeIcon icon="question-circle" />
        </div>

        <div className="confirmation-modal-header"dangerouslySetInnerHTML={ {__html: title} }  />
        <div className="confirmation-modal-text" dangerouslySetInnerHTML={ {__html: message} } />
        <div className="confirmation-modal-buttons">
          <button
            name={ okButtonName }
            className="btn btn-close-modal action-btn"
            onClick={
              () => {
                onOk();
                closeModal();
              }
            }
          >
            {okButtonText}
          </button>

          <button
            name={ cancelButtonName }
            className="btn btn-close-modal blue-btn secondary-btn"
            onClick={ () => {
              onClose();
              closeModal();
              }
            }
          >
            {cancelButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
